import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Textbox } from "components/Textbox/Textbox";
import { get } from "http";
import { useContext, useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";

import { GUID_EMPTY, ICON_TYPE } from "utils/constants";
import { trans } from "utils/helpers";
import { getItemGroupFilter } from "./api";
import { PropertiesFilterBox } from "./PropertiesFilterBox";
import { FilterBox } from "../FilterBox/FilterBox";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";

interface ItemCardsProps {
  setfilterList: (data: any) => void;
  filterData?: any;
  handleFilter?: any;
  itemGroupId?: any;
  handleRemoveFilter?: any;
  filterObj?: any;
  setfilterObj?:any
}

export const ItemGroupFilterBox = ({
  setfilterList,
  filterData,
  itemGroupId,
  handleFilter,
  handleRemoveFilter,
  filterObj,
  setfilterObj
}: ItemCardsProps) => {
  const [showStep, setShowStep] = useState<any>({ 3: true });
    const [itemGroupFilters, setItemGroupFilters] = useState<any>("");
  const { sidebarIsOpen,emptyBasket ,setLayoutEcommrceConstraint } = useContext(LayoutContext);
  const formRef=useRef<any>()

   async function getItemGroupFilterAsync() {  
            try {
                const response = await getItemGroupFilter(itemGroupId);
                console.log("response", response.Data);
                if (response.Data) {
                    setItemGroupFilters(response.Data);
                }
            } catch (error) {
            }

     }
     function handelStringFilter(){
        
        let list:any = []
       const elements = formRef.current?.elements;
        for (let i = 0; i < elements?.length; i++) {
          const el = elements[i];
          if (el.tagName === 'INPUT') {
            if (el.type === 'checkbox' && el.checked) {
                list.push(el.value)
            } else if (el.type === 'text' && el.value) {
                list.push(el.value)
            }
          }
        }
        setfilterList(list)
     }


  useEffect(() => {
    console.log("itemGroupId", itemGroupId);
    if (itemGroupId ) {
      getItemGroupFilterAsync();
    }
  }, [itemGroupId]);    

  return (
    <>
   
   <div style={{height:`${(itemGroupId&& itemGroupId != GUID_EMPTY)?'83%':'auto'}`,overflowX:'hidden',overflowY:'auto'}} className="mb-2">
     <FilterBox
            filterObj={filterObj}
              setfilterObj={(e) => {
                setfilterObj({ ...filterObj, ...e });
              }}
              filterData={{ type: 1, title: "بر اساس قیمت" }}
              handleFilter={()=>{
                if (filterObj.min != null || filterObj.max != null) {
                 handleFilter()
                }
                
              }}
              handleRemoveFilter={()=>{
              
               handleRemoveFilter()
                
              }}
            />
    { (itemGroupId&& itemGroupId != GUID_EMPTY)? <form ref={formRef} >
      <div className={`card mb-3 `}>
        <div
          style={{
            backgroundColor: "#f97316",
            color: "#fff",
            paddingRight: "20px",
            justifyContent: "space-between",
          }}
          className="d-flex  py-1 col-12 pr-4"
        >
          <div style={{ whiteSpace: "nowrap" }}>{filterData.title}</div>
          <div
            style={{ marginLeft: "18px" }}
            onClick={() => {
              showStep[1]
                ? setShowStep({ ...showStep, 1: false })
                : setShowStep({ ...showStep, 1: true });
            }}
          >
            {showStep[1] ? (
              <FontAwesomeIcon
                icon={[ICON_TYPE, "angle-down"]}
                size="lg"
                className="icon"
              />
            ) : (
              <FontAwesomeIcon
                icon={[ICON_TYPE, "angle-up"]}
                size="lg"
                className="icon"
              />
            )}
          </div>
        </div>
        <div
          style={{ display: !showStep[1] ? "block" : "none" }}
          className="card-body"
        >
          {itemGroupFilters&& Object.keys(itemGroupFilters).map(item=>
              <PropertiesFilterBox
                  ItemPropertyId={itemGroupFilters[item]}
                  label={item} 
                  setfilterObj={function (data: any): void {
                      throw new Error("Function not implemented.");
                  } }  />
          )}
       
        
        </div>
      </div>
    </form>:<></>}
   </div>
 
    <div className=" row gx-1 justify-content-between mb-1 me-1" style={{height:'10%',width:'96%'}}>
          <div className="col-12  ps-0 mb-2 ">
            <button
              className="btn-customerPrimaryColor w-100  d-block border-0 btn-sm "
              type="submit"
              onClick={handelStringFilter}
              style={{ fontSize: "12px" }}
            >
              <div className="row">
                <div className="col-8 p-0">{trans("filter")}</div>
                <div className="col-4 p-0">
                  <FontAwesomeIcon
                    icon={["fas", "filter"]}
                    className="text-white "
                  />
                </div>
              </div>
            </button>
          </div>
          <div className="col-12  ps-0">
            <button
              className="btn-customerPrimaryColor border-0 btn-sm w-100 d-block "
              onClick={() => {
                handleRemoveFilter()
              }}
              style={{ fontSize: "12px" }}
            >
              <div className="row">
                <div className="col-8 p-0">{trans("حذف فیلتر")}</div>
                <div className="col-4 p-0">
                  <FontAwesomeIcon
                    icon={["fas", "filter"]}
                    className="text-white "
                  />
                </div>
              </div>
            </button>
          </div>
        </div>
    </>
  
  );
};
